import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Sign in with Apple inside the native shell: iOS's own sheet instead of the
// web redirect (docs/DOORS.md § Sign in with Apple, native). On the plain web
// `enabled` is false and the button's form posts to omniauth as always.
//
// A failure is said on the page, in the `error` line beside the button (the
// button cannot hold it); a closed sheet is silent, a shell `failed` is not; `{ to }` visits /in.
export default class extends BridgeComponent {
  static component = "apple";
  static targets = ["error"];
  static values = { say: String }; // the line when the server gave none, in the page's language

  async signin(event) {
    if (!this.enabled) return;
    event.preventDefault();
    this.say("");

    try {
      const { nonce, error } = await this.post("/apple/nonce");
      if (!nonce) return this.say(error);
      this.send("signin", { nonce }, async ({ data }) => {
        if (data.failed) return this.say(); // the shell failed, not a cancel
        if (!data.idToken) return; // closed the sheet
        try {
          const { to, error } = await this.post("/apple/signin", {
            id_token: data.idToken,
            code: data.code,
            name: data.name,
          });
          // The shell replaces its root: the one underneath is a stale signed-out
          // page. /in is the server's trampoline, no destination off the wire
          // (docs/DOORS.md § Sign in inside the shell).
          if (to) window.Turbo.visit("/in", { action: "replace" });
          else this.say(error);
        } catch {
          this.say();
        }
      });
    } catch {
      this.say();
    }
  }

  // The answer's JSON, or { error } when the server refused: a non-JSON body
  // (an HTML 429 or 500) is a refusal with no sentence of its own.
  async post(url, body = {}) {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
      body: JSON.stringify(body),
    });
    const json = await res.json().catch(() => ({}));
    return res.ok ? json : { error: json.error };
  }

  say(message) {
    if (!this.hasErrorTarget) return;
    const text = message === "" ? "" : message || this.sayValue;
    this.errorTarget.textContent = text;
    this.errorTarget.hidden = !text;
  }
}
